import {
	CallToAction,
	CtaStyle,
	getButtonTypeFromCtaStyle,
	SecondaryCallToAction,
} from '../../../../_storybook-helpers/ctaControls';
interface CtaProps {
	cta: CallToAction;
	secondaryCta?: SecondaryCallToAction;
	ctaCustomClass?: string;
}

export const renderCta = (data: CtaProps) => {
	const { cta, secondaryCta, ctaCustomClass = '' } = data;
	if (!cta.label) return '';
	const primaryBtnType = getButtonTypeFromCtaStyle(cta.style as CtaStyle);
	const primaryBtnColor = (
		primaryBtnType !== 'tertiary' ? cta.buttonBg : 'white'
	).replace('ds-', '');
	const btn = `
	<div class="ds-button ${ctaCustomClass}" type="${primaryBtnType}" color="${primaryBtnColor}">
		<a
		class="ds-button-container"
		data-link-event="${`cta: ${cta.label}`}"
		target="${cta.mode}"
		href="${cta.url}"
		${cta.linkTitle ? `title="${cta.linkTitle}"` : ''}
		${cta.ariaLabel ? `aria-label="${cta.ariaLabel}"` : ''}
		>
			<span>
				${cta.label} <i class="fa ${cta.icon}" aria-hidden="true"></i>
			</span>
		</a>
	</div>
	`;
	const secondaryBtnType = getButtonTypeFromCtaStyle(
		secondaryCta?.style as CtaStyle
	);
	const secondaryBtnColor =
		secondaryBtnType !== 'tertiary' ? secondaryCta?.buttonBg : 'white';
	const optionalBtn = secondaryCta?.label
		? `<div class="ds-button" type="${secondaryBtnType}" color="${secondaryBtnColor}">
		<a
		class="ds-button-container"
		data-link-event="${`cta: ${secondaryCta.label}`}"
		target="${secondaryCta.mode}"
		href="${secondaryCta.url}"
		${secondaryCta.linkTitle ? `title="${secondaryCta.linkTitle}"` : ''}
		${secondaryCta.ariaLabel ? `aria-label="${secondaryCta.ariaLabel}"` : ''}
		>
			<span>
				${secondaryCta.label} <i class="fa ${secondaryCta.icon}" aria-hidden="true"></i>
			</span>
		</a>
	</div>
	`
		: '';
	return `${btn} ${optionalBtn}`;
};
